<template>
  <div class="animated fadeIn">
    <div class="font-bold mb-10">Sales Back to Basic</div>
    <div class="box-mini">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <div class="col-12">
          <div class="overflow-auto">
            <table class="table table-responsive table-striped text-center mb-0">
              <thead>
                <tr>
                    <th rowspan="3">Employee ID</th>
                    <th rowspan="3">Membership Advisor Name</th>
                    <th rowspan="3">Branch Name</th>
                    <th colspan="42">Production</th>
                    <template v-if="dataMembership.length > 0">
                      <th :colspan="(dataMembership?dataMembership.length:0)*2*3">Type Membership</th>
                    </template>
                    <template v-else>
                      <th></th>
                    </template>
                </tr>
                <tr>
                  <th colspan="3">Call Made</th>
                  <th colspan="3">Appointment Made</th>
                  <th colspan="3">Appointments Reschedule</th>
                  <th colspan="3">Appointment</th>
                  <th colspan="3">%Appointment Ratio</th>
                  <th colspan="3">Shows</th>
                  <th colspan="3" style="min-width:150px">%Show Ratio</th>
                  <th colspan="3">Walk In</th>
                  <th colspan="3">Interview</th>
                  <th colspan="3">Sales</th>
                  <th colspan="3" style="min-width:150px">%Closing Ratio</th>
                  <th colspan="3">Refferals</th>
                  <!-- <th colspan="2">Telephone Inquiry</th> -->
                  <th colspan="3">Web Lead</th>
                  <th colspan="3">Others Lead</th>
                  <th colspan="3">Total Source Lead</th>
                  <th v-for="(values, index) in dataMembership" :key="index+'name'" colspan="3">{{values.name}}</th>
                </tr>
                <tr>
                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>

                  <th>D</th>
                  <th>M</th>
                  <th>Y</th>
                  <template v-for="(values, index) in dataMembership">
                    <th :key="index + 'first'">D</th>
                    <th :key="index + 'second'">M</th>
                    <th :key="index + 'third'">Y</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                  <tr class="time-schedule" v-for="values in items" :key="values.id">
                    <td>
                      <div>
                        {{values.branch ? values.branch.codename : 'FT'}}{{values.owner_id}}
                      </div>
                    </td>
                    <td>
                      <div v-if="values.fullname">
                        {{values.fullname}}
                      </div>
                    </td>
                    <td>
                      {{values.branch.codename}}
                    </td>

                    <td @click="getCallMade(values.owner_id, 'daily')">
                      <a href="#" class="text-dark">
                        <h6><u>{{ ifValueIsNan(values.call_made_daily)}}</u></h6>
                      </a>
                    </td>
                    <td @click="getCallMade(values.owner_id, 'monthly')">
                      <a href="#" class="text-dark"><h6><u>{{ ifValueIsNan(values.call_made_monthly)}}</u></h6></a>
                    </td>
                    <td>{{values.call_made_yearly}}</td>
                    <td @click="getAppoitmentMade(values.owner_id)">
                      <!-- <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(values.appointment_made_daily + values.appointment_made_reschedule_daily)}}</u></h6></a> -->
                      <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(values.appointment_made_daily)}}</u></h6></a>
                    </td>
                    <td @click="getAppoitmentMade(values.owner_id)">
                      <!-- <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(values.appointment_made_monthly + values.appointment_made_reschedule_monthly)}}</u></h6></a> -->
                      <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(values.appointment_made_monthly)}}</u></h6></a>
                    </td>
                    <td>{{values.appointment_made_yearly}}</td>

                    <!-- Appointment Reschedule -->
                    <td>
                      {{values.appointment_made_reschedule_daily}}
                    </td>
                    <td>
                      {{values.appointment_made_reschedule_monthly}}
                    </td>
                    <td>
                      {{values.appointment_made_reschedule_yearly}}
                    </td>

                    <!-- Appointment -->
                    <td @click="getAppoitmentDetail(values.owner_id, '')">
                      <a href="#" class="text-dark"><h6><u>{{values.appointment_daily}}</u></h6></a>
                    </td>
                    <td @click="getAppoitmentDetail(values.owner_id, 'yes')">
                      <a href="#" class="text-dark"><h6><u>{{values.appointment_monthly}}</u></h6></a>
                    </td>
                    <td>
                      {{values.appointment_yearly}}
                    </td>
                    <!-- appointment ach -->
                    <td>
                      {{ifValueIsNan(parseFloat((values.appointment_made_daily/values.call_made_daily)* 100).toFixed(2))}}%
                    </td>
                    <td>
                       {{ifValueIsNan(parseFloat((values.appointment_made_monthly/values.call_made_monthly)*100).toFixed(2))}}%
                    </td>
                    <td>
                       {{ifValueIsNan(parseFloat((values.appointment_made_yearly/values.call_made_yearly)*100).toFixed(2))}}%
                    </td>

                    <!-- Show -->
                    <td>
                      {{ifValueIsNan(values.show_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.show_monthly)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.show_yearly)}}
                    </td>

                    <!-- Show Ratio -->
                    <td>
                      {{values.shows_percent_daily}}%
                    </td>
                    <td>
                      {{values.shows_percent_monthly}}%
                    </td>
                    <td>
                      {{values.shows_percent_yearly}}%
                    </td>

                    <!-- Walk In -->
                    <td @click="getWalkIn(values.owner_id, 'daily')">
                      <a href="#" class="text-dark"><h6><u>{{values.walk_in_daily}}</u></h6></a>
                    </td>
                    <td @click="getWalkIn(values.owner_id, 'monthly')">
                      <a href="#" class="text-dark"><h6><u>{{values.walk_in_monthly}}</u></h6></a>
                    </td>
                    <td>
                      {{values.walk_in_yearly}}
                    </td>

                    <!-- Interview -->
                    <td @click="getInterview(values.owner_id, 'daily')">
                      <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(parseInt(values.walk_in_daily) + parseInt(values.show_daily))}}</u></h6></a>
                    </td>
                    <td @click="getInterview(values.owner_id, 'monthly')">
                      <a href="#" class="text-dark"><h6><u>{{ifValueIsNan(values.walk_in_monthly + values.show_monthly )}}</u></h6></a>
                    </td>
                    <td>{{ ifValueIsNan(values.walk_in_yearly + values.show_yearly ) }}</td>

                    <!-- Sales -->
                    <td>
                      {{ifValueIsNan(values.sales_daily + values.member_rejoin_membership_daily + values.change_membership_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.sales_monthly + values.member_rejoin_membership_monthly + values.change_membership_monthly)}}
                    </td>
                    <td>{{ifValueIsNan(values.sales_yearly + values.member_rejoin_membership_yearly + values.change_membership_yearly)}}</td>

                    <!-- Closing Ratio -->
                    <td>
                      <!-- {{ifValueIsNan(values.close_percent_daily)}}% -->
                      {{ifValueIsNan(((values.sales_daily + values.member_rejoin_membership_daily + values.change_membership_daily)/(parseInt(values.walk_in_daily) + parseInt(values.show_daily)) * 100).toFixed(2))}}%
                    </td>
                    <td>
                      {{ifValueIsNan(((values.sales_monthly + values.member_rejoin_membership_monthly + values.change_membership_monthly)/(parseInt(values.walk_in_monthly) + parseInt(values.show_monthly)) * 100).toFixed(2))}}%
                    </td>
                    <td>
                      {{ifValueIsNan(((values.sales_yearly + values.member_rejoin_membership_yearly + values.change_membership_yearly)/(parseInt(values.walk_in_yearly) + parseInt(values.show_yearly)) * 100).toFixed(2))}}%
                    </td>

                    <!-- Referral -->
                    <td>
                      {{ifValueIsNan(values.referral_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.referral_monthly)}}
                    </td>
                    <td>{{ values.referral_yearly }}</td>
                    <!-- <td>
                      {{values.telephone_inquiry_daily}}
                    </td>
                    <td>
                      {{values.telephone_inquiry_monthly}}
                    </td> -->

                    <!-- Web Lead -->
                    <td>
                      {{ifValueIsNan(values.web_lead_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.web_lead_monthly)}}
                    </td>
                    <td>{{ values.web_lead_yearly }}</td>

                    <!-- Others Lead -->
                    <td>
                      {{ifValueIsNan(values.others_lead_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.others_lead_monthly)}}
                    </td>
                    <td>{{ values.others_lead_yearly }}</td>

                    <!-- Total Source Lead  -->
                    <td>
                      {{ifValueIsNan(values.referral_daily + values.web_lead_daily + values.telephone_inquiry_daily + values.others_lead_daily)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.referral_monthly + values.web_lead_monthly + values.telephone_inquiry_monthly + values.others_lead_monthly)}}
                    </td>
                    <td>
                      {{ifValueIsNan(values.referral_yearly + values.web_lead_yearly + values.telephone_inquiry_yearly + values.others_lead_yearly)}}
                    </td>
                    <template v-for="(valuex, index) in dataMembership">
                      <td>{{values.membership[toSnakeCase(valuex.name)+'_daily']}}</td>
                      <td>{{values.membership[toSnakeCase(valuex.name)+'_monthly']}}</td>
                      <td>{{values.membership[toSnakeCase(valuex.name)+'_yearly']}}</td>
                    </template>


                  </tr>
              </tbody>
            </table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
        <div class="box-mini">
          <div class="p-15">
                    <div class="row">
                      <div class="col-sm-4">
                        <table>
                          <tr>
                            <td><a @click="exportReportSummary()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>

                          </tr>
                        </table>
                      </div>
                    </div>

            <!-- Summary -->
            <div class="overflow-auto">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr>
                    <th colspan="3">Call Made</th>
                    <th colspan="3">Appointment Made</th>
                    <th colspan="3">Appointment</th>
                    <th colspan="3">Shows</th>
                    <th colspan="3">%Shows</th>
                    <th colspan="3">Walk In</th>
                    <th colspan="3">Interview</th>
                    <th colspan="3">Sales</th>
                    <th colspan="3">%Close</th>
                    <th colspan="3">Refferals</th>
                    <!-- <th colspan="2">Telephone Inquiry</th> -->
                    <th colspan="3">Web Lead</th>
                    <th colspan="3">Others Lead</th>
                    <th colspan="3">Total Source Lead</th>
                  </tr>
                  <tr>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <th>D</th>
                    <th>M</th>
                    <th>Y</th>
                    <!-- <th>D</th>
                    <th>M</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td> {{this.summary.call_made_daily}}</td>
                    <td> {{this.summary.call_made_monthly}}</td>
                    <td> {{this.summary.call_made_yearly}}</td>
                    <td> {{this.summary.appointment_made_daily}}</td>
                    <td> {{this.summary.appointment_made_monthly}}</td>
                    <td> {{this.summary.appointment_made_yearly}}</td>
                    <td> {{this.summary.appointment_daily}}</td>
                    <td> {{this.summary.appointment_monthly}}</td>
                    <td> {{this.summary.appointment_yearly}}</td>
                    <td> {{this.summary.show_daily + this.summary.walk_in_daily}}</td>
                    <td> {{this.summary.show_monthly + this.summary.walk_in_monthly}}</td>
                    <td> {{this.summary.show_yearly + this.summary.walk_in_yearly}}</td>
                    <td> {{parseFloat(((this.summary.show_daily + this.summary.walk_in_daily) / this.summary.appointment_daily) * 100).toFixed(2)}}%</td>
                    <td> {{parseFloat(((this.summary.show_monthly + this.summary.walk_in_monthly) / this.summary.appointment_monthly) * 100).toFixed(2)}}%</td>
                    <td> {{parseFloat(((this.summary.show_yearly + this.summary.walk_in_yearly) / this.summary.appointment_yearly) * 100).toFixed(2)}}%</td>
                    <td> {{this.summary.walk_in_daily}}</td>
                    <td> {{this.summary.walk_in_monthly}}</td>
                    <td> {{this.summary.walk_in_yearly}}</td>

                    <td> {{(this.summary.show_daily + this.summary.walk_in_daily) + this.summary.walk_in_daily}} </td>
                    <td> {{(this.summary.show_monthly + this.summary.walk_in_monthly) + this.summary.walk_in_monthly}} </td>
                    <td> {{(this.summary.show_yearly + this.summary.walk_in_yearly) + this.summary.walk_in_yearly}} </td>
                    <!-- <td> {{this.summary.total_sales_daily}}</td>
                    <td> {{this.summary.total_sales_monthly}}</td> -->
                    <td> {{this.summary.sales_daily}}</td>
                    <td> {{this.summary.sales_monthly}}</td>
                    <td> {{this.summary.sales_yearly}}</td>

                    <!-- {{ifValueIsNan(((values.sales_yearly + values.member_rejoin_membership_yearly + values.change_membership_yearly)/(parseInt(values.walk_in_yearly) + parseInt(values.show_yearly)) * 100).toFixed(2))}}% -->

                    <td> {{parseFloat((this.summary.sales_daily / this.summary.interview_daily) * 100).toFixed(2)}}%</td>
                    <td> {{parseFloat((this.summary.sales_monthly / this.summary.interview_monthly) * 100).toFixed(2)}}%</td>
                    <td> {{parseFloat((this.summary.sales_yearly / this.summary.interview_yearly) * 100).toFixed(2)}}%</td>

                    <td> {{this.summary.referral_daily}}</td>
                    <td> {{this.summary.referral_monthly}}</td>
                    <td> {{this.summary.referral_yearly}}</td>
                    <!-- <td> {{this.summary.telephone_inquiry_daily}}</td>
                    <td> {{this.summary.telephone_inquiry_monthly}}</td> -->
                    <td> {{this.summary.web_lead_daily}}</td>
                    <td> {{this.summary.web_lead_monthly}}</td>
                    <td> {{this.summary.web_lead_yearly}}</td>

                    <td> {{this.summary.others_daily}}</td>
                    <td> {{this.summary.others_monthly}}</td>
                    <td> {{this.summary.others_yearly}}</td>

                    <td> {{this.summary.referral_daily + this.summary.web_lead_daily + this.summary.telephone_inquiry_daily + this.summary.others_daily}}</td>
                    <td> {{this.summary.referral_monthly + this.summary.web_lead_monthly + this.summary.telephone_inquiry_monthly + this.summary.others_monthly}}</td>
                    <td> {{this.summary.referral_yearly + this.summary.web_lead_yearly + this.summary.telephone_inquiry_yearly + this.summary.others_yearly}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'total_active_member'" centered title="Call Made">
      <table class="w-100 table table-striped table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Leads Cource</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Tanggal</th>
          </tr>
        </thead>
        <tbody>
         <tr v-for="(item, index) in detail_leads_data" :key="item.leads_id">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.leads_source }}</td>
          <td>{{ item.phone_number }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.tanggal }}</td>
         </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- Appointment Made -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'total_active_member_2'" centered title="Appointment Made">
      <table class="table table-striped table-bordered w-100">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Leads Cource</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Appointment Made</th>
            <th>Appointment Date</th>
          </tr>
        </thead>
        <tbody>
         <tr v-for="(item, index) in detail_leads_data" :key="item.leads_id">
          <th>{{ index + 1 }}</th>
          <td>{{ item.name }}</td>
          <td>{{ item.leads_source }}</td>
          <td>{{ item.phone_number }}</td>
          <td>{{ item.email }}</td>
          <td>{{ formatDate(item.tanggal) }}</td>
          <td>{{ item.tanggal_appt }}</td>
         </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- Appointment Detail -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'appointment_detail'" centered title="Appointment">
      <table class="table table-striped table-bordered w-100">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Leads Cource</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Tanggal</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
         <tr v-for="(item, index) in detail_leads_data" :key="item.leads_id">
          <th>{{ index + 1 }}</th>
          <td>{{ item.name }}</td>
          <td>{{ item.leads_source }}</td>
          <td>{{ item.phone_number }}</td>
          <td>{{ item.email }}</td>
          <td>{{ formatDate(item.tanggal) }}</td>
          <td>{{ item.start_time }}</td>
         </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- Walk In -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'walk_in_detail'" centered title="Walk In">
      <table class="table table-striped table-bordered w-100">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Leads Cource</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Tanggal</th>
          </tr>
        </thead>
        <tbody>
         <tr v-for="(item, index) in detail_leads_data" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.leads_source }}</td>
          <td>{{ item.phone_number }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.tanggal }}</td>
         </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- Interview -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'interview_detail'" centered title="Interview">
      <table class="table table-striped table-bordered w-100">
        <thead>
          <tr>
            <th>No</th>
            <th>Name</th>
            <th>Leads Cource</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>Tanggal</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
         <tr v-for="(item, index) in detail_leads_data" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.leads_source }}</td>
          <td>{{ item.phone_number }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.tanggal }}</td>
          <td>{{ item.interview_type }}</td>
         </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'


export default {
  name: 'salesbacktobasic',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      index: 1,
      items: [],
      items2: [],
      detail_leads_data: [],
      summary: [],
      dataBranch: [],
      branch_id: null,
      current_branch_id: null,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      dateString: '27-07-1993',
      itemsMembership: '',
      dataMembership: [],
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    ifValueIsNan(val) {
      if (isNaN(val)) {
        return 0
      } else {
        return isFinite(val) ? val : 0
      }
    },
    onChange(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    removeZero(event) {
      return parseFloat(event)
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    toSnakeCase(str) {
        return str
            .replace(/([a-z0-9])([A-Z])/g, '$1_$2') // camelCase to snake_case
            .replace(/\s+/g, '_')                  // spaces to underscores
            .replace(/-+/g, '_')                   // hyphens to underscores
            .replace(/__+/g, '_')                  // multiple underscores to single underscore
            .toLowerCase()                         // convert to lowercase
            .replace(/^_+|_+$/g, '');              // remove leading/trailing underscores
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    formatDate (value, format="YYYY-MM-DD") {
      return moment(value).format(format)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    countShowsDaily (value) {
      var data = value.show_daily
      var percentage = 0
      if (value.appointment_daily === 0) {
        percentage = 0
        return percentage
      }
      else {
        percentage = (data/value.appointment_daily) * 100
        return percentage.toFixed()
      }
    },
    countCancel (value, key) {
      let result = ((value[`sales_${key}`] / value[`show_${key}`]) * 100).toFixed()
      if (!parseInt(result)) result = 0
      return `${result}%`
    },
    countShowsMonthly (value) {
      var data = value.show_monthly
      var percentage = 0
      if (value.appointment_monthly === 0) {
        percentage = 0
        return percentage
      }
      else {
        percentage = (data/value.appointment_monthly) * 100
        return percentage.toFixed()
      }
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      if (!dates[1]){
        dates[1] = dates[0]
      }

      let url = 'crm/v1/export/sales_report/sales_back_to_basic?start='+dates[0]+'&end='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) {
        url += '&sales_id=' + Auth.Session.get().paradigm_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Sales Back to Basic '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },

    exportReportSummary() {
      let dates = this.exportDates.split(' to ')
      if (!dates[1]){
        dates[1] = dates[0]
      }

      let url = 'crm/v1/export/sales_report/summary_sales_back_to_basic?start='+dates[0]+'&end='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) {
        url += '&sales_id=' + Auth.Session.get().paradigm_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Sales Back to Basic '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch (event) {
      this.loadingActive = true
      this.current_branch_id = event
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_back_to_basic?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start=' + dates1[0]
      + '&end=' + dates1[1]

      let url2 = 'crm/v1/sales_report/summary_sales_back_to_basic?start=' + dates1[0]
      + '&end=' + dates1[1]

      if (event != null) {
        url += '&branch_id=' + event
        url2 += '&branch_id=' + event
      }

      if (this.getRoleId == 3) {
        url += '&sales_id=' + Auth.Session.get().paradigm_id
        url2 += '&sales_id=' + Auth.Session.get().paradigm_id
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount

        var memberships = []
        for (let i = 0; i < this.items.length; i++) {
          const el = this.items[i];
          const membership = el.membership_list
            if (membership) {
              for (let j = 0; j < membership.length; j++) {
              let element = membership[j];
              if (element) {
                memberships.push(element)
              }
            }
          }
        }
        // remove duplicate data by value
        memberships = [...new Map(memberships.map(item => [item.name, item])).values()];
        console.log('List membership: ', this.items)
        this.dataMembership = memberships

        var items = []
        for (let i = 0; i < this.items.length; i++) {
          const el = this.items[i];
          if (el) {
            let new_membership = Object()
            for (let m = 0; m < this.dataMembership.length; m++) {
              const membership = this.dataMembership[m];
              const membershipNameDaily = `${this.toSnakeCase(membership.name)}_daily`
              const membershipNameMonthly = `${this.toSnakeCase(membership.name)}_monthly`
              if (membershipNameDaily in el.membership) {
                new_membership[membershipNameDaily] = el.membership[membershipNameDaily]
                new_membership[membershipNameMonthly] = el.membership[membershipNameMonthly]
              } else {
                new_membership[membershipNameDaily] = 0
                new_membership[membershipNameMonthly] = 0
              }
            }
            el.membership = new_membership
          }

          items.push(el)
        }

        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
      })

      axios.get(url2).then(response => {
        this.summary = response.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCallMade(owner_id, range) {
      this.detail_leads_data = []
      let dates1 = this.exportDates.split(' to ')
      let end_date = dates1[1] == undefined ? dates1[0] : dates1[1]
      let url = 'crm/v1/sales_report/sales_back_to_basic/call_made?'
        + 'start_date=' + dates1[0]
        + '&end_end=' + end_date
        + '&owner_id=' + owner_id
        + '&range=' + range

      axios.get(url).then(response => {
        console.log('call_made',response)
        this.detail_leads_data = response.data.data
        this.showModal2('total_active_member')

      }).catch(error => {
        console.log('error', error)
      })
    },
    getWalkIn(owner_id, range) {
      this.detail_leads_data = []
      let dates1 = this.exportDates.split(' to ')
      let end_date = dates1[1] == undefined ? dates1[0] : dates1[1]
      let url = 'crm/v1/sales_report/sales_back_to_basic/walk_in?'
        + 'start_date=' + dates1[0]
        + '&end_end=' + end_date
        + '&owner_id=' + owner_id
        + '&range=' + range

      axios.get(url).then(response => {
        this.detail_leads_data = response.data.data
        this.showModal2('walk_in_detail')
      }).catch(error => {
        console.log('error', error)
      })
    },
    getInterview(owner_id, range) {
      this.detail_leads_data = []
      let dates1 = this.exportDates.split(' to ')
      let end_date = dates1[1] == undefined ? dates1[0] : dates1[1]
      let url = 'crm/v1/sales_report/sales_back_to_basic/interview?'
        + 'start_date=' + dates1[0]
        + '&end_end=' + end_date
        + '&owner_id=' + owner_id
        + '&range=' + range

      axios.get(url).then(response => {
        this.detail_leads_data = response.data.data
        this.showModal2('interview_detail')
      }).catch(error => {
        console.log('error', error)
      })
    },
    showModal2 (id) {
      this.$refs[id].show()
    },
    getAppoitmentMade(owner_id) {
      this.detail_leads_data = []

      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_back_to_basic/appoitment_made?'
        + 'start_date=' + dates1[0]
        + '&end_end=' + dates1[1]
        + '&owner_id=' + owner_id

      axios.get(url).then(response => {
        console.log('call_made',response)
        this.detail_leads_data = response.data.data
        this.showModal2('total_active_member_2')
      }).catch(error => {
        console.log('error', error)
      })
    },
    getAppoitmentDetail(owner_id, is_month='') {
      this.loadingActive = true
      this.detail_leads_data = []

      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_back_to_basic/appoitment_detail?'
        + 'start_date=' + dates1[0]
        + '&end_end=' + dates1[1]
        + '&owner_id=' + owner_id
        + '&is_month=' + is_month

      axios.get(url).then(response => {
        this.loadingActive = false
        this.detail_leads_data = response.data.data
        this.showModal2('appointment_detail')
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    fetchData() {
      let url_branch = `fitness/v1/branch?paradigm_id=${this.getID}&paradigm_role_id=${this.getRoleId}`

      url_branch = `fitness/v1/branch/`;

      axios.get(url_branch).then(response => {
        this.dataBranch = response.data.data.rows

        // login susan
        if (this.getRoleId == 20 && Auth.Session.get().paradigm_id == 15101924) {
          this.branch_id = Auth.Session.get().paradigm_branch_id
          let filter = this.dataBranch.filter(item => item.id == Auth.Session.get().paradigm_branch_id)
          this.dataBranch = filter
        }
      }).catch(error => {
        console.log('error', error)
      })

      this.loadingActive = true
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_back_to_basic?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start=' + dates1[0]
        + '&end=' + dates1[1]

      let url2 = 'crm/v1/sales_report/summary_sales_back_to_basic?start=' + dates1[0]
        + '&end=' + dates1[1]

      if (this.current_branch_id != null) {
        url += '&branch_id=' + this.current_branch_id
        url2 += '&branch_id=' + this.current_branch_id
      }

      if (this.getRoleId == 3) {
        url += '&sales_id=' + Auth.Session.get().paradigm_id
        url2 += '&sales_id=' + Auth.Session.get().paradigm_id
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount

        var memberships = []
        for (let i = 0; i < this.items.length; i++) {
          const el = this.items[i];
          const membership = el.membership_list

            if (membership) {
              for (let j = 0; j < membership.length; j++) {
              const element = membership[j];

              if (element) {
                Object.assign(el.membership_list[j], {
                  daily: el.membership[`${this.toSnakeCase(element.name)}_daily`],
                  monthly: el.membership[`${this.toSnakeCase(element.name)}_monthly`],
                })
                memberships.push(element)
              }
            }
          }
        }
        // remove duplicate data by value
        memberships = [...new Map(memberships.map(item => [item.name, item])).values()];
        console.log('List membership: ', memberships)
        this.dataMembership = memberships

        var items = []
        for (let i = 0; i < this.items.length; i++) {
          const el = this.items[i];
          if (el) {
            let new_membership = Object()
            for (let m = 0; m < this.dataMembership.length; m++) {
              const membership = this.dataMembership[m];
              const membershipNameDaily = `${this.toSnakeCase(membership.name)}_daily`
              const membershipNameMonthly = `${this.toSnakeCase(membership.name)}_monthly`
              const membershipNameYearly = `${this.toSnakeCase(membership.name)}_yearly`
              if (membershipNameDaily in el.membership) {
                new_membership[membershipNameDaily] = el.membership[membershipNameDaily]
                new_membership[membershipNameMonthly] = el.membership[membershipNameMonthly]
                new_membership[membershipNameYearly] = el.membership[membershipNameYearly]
              } else {
                new_membership[membershipNameDaily] = 0
                new_membership[membershipNameMonthly] = 0
                new_membership[membershipNameYearly] = 0
              }
            }
            el.membership = new_membership
          }

          items.push(el)
        }

        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
      })

      axios.get(url2).then(response => {
        this.summary = response.data
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/membership?sorting=id&sorting_type=asc&is_revenue=1&is_show_report=1').then(response => {
        this.itemsMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })


    }
  },
  created () {
    // login susan
    if (this.getRoleId == 20 && Auth.Session.get().paradigm_id == 15101924) {
      this.current_branch_id = Auth.Session.get().paradigm_branch_id
    }
    this.fetchData()
  }
}
</script>

<style>
</style>
